<template>
    <div class="input-group" id="inputGroup">
        <ul class="hs-ul">
            <li class="hs-search-input">
                <div class="input-group col-sm hs-input" id="search">
                    <ul class="hs-input-ul">
                        <li v-show="currTab==0"><input type="text" class="search mainland_search "
                                                       id="searchTxt"
                                                       :placeholder="$t('searchPlaceholder')"
                                                       v-model="Input.rpc_input"
                                                       @keyup.enter="search()"></li>
                        <li v-show="currTab==1"><input type="text" class="search wc_search "
                                                       :placeholder="$t('PersonalORorganizationName')"
                                                       v-model="Input.wc_input"
                                                       @keyup.enter="search()"></li>
                        <li v-show="currTab==2" class="abroad-input-li">
                            <input type="text" class="abroad_search "
                                   :placeholder="$t('FEnterfullameEnterprise')"
                                   v-model="Input.norpc_input" @keyup.enter="search()">
                            <v-select :options="CountryData" class="muli-select chosen-select"
                                      v-model="Input.norpc_country"
                                      :placeholder="$t('ChooseCountryOfEnterprise')">
                            </v-select>
                        </li>
                    </ul>
                    <div class="hs-select-input" @click.stop="ifShowSelectUl=!ifShowSelectUl">
                        <div class="Segmenting-line"></div>
                        <input style="background: #fff" class="hs-select-input-Choice "
                               id="HsSelectInputChoise" type="text" :placeholder="$t('PRC')"
                               disabled="disabled" :value="currTabName"/>
                        <ul class="hs-select-css hs-select-ul" v-show="ifShowSelectUl">
                            <li @click="currTab=0">{{ $t('PRC') }}</li>
                            <li @click="currTab=1" class="WorldCheck">{{ $t('GlobalCheck') }}</li>
                            <li @click="currTab=2" class="NonPRC">{{ $t('NonPRC') }}</li>
                            <router-link to="/advanced/screening">
                                <li class="hs-Screening"><a>{{ $t('Advanced') }}</a></li>
                            </router-link>
                        </ul>
                        <i class="fa fa-caret-down fa-lg"></i>
                    </div>
                    <span class="input-search-btn" @click="search()">
            <i class="fa fa-search fa-lg"></i>
          </span>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: ['currtab'],
        data() {
            return {
                currTab: this.currtab || 0,
                ifShowSelectUl: false, // 默认不显示头部下拉
                Input: { // 输入内容组
                    rpc_input: '',
                    norpc_input: '',
                    norpc_country: null, // 默认为null则不显示删除图标
                    wc_input: ''
                },
                CountryData: []
            }
        },
        methods: {
            /**
             * @name: search
             * @description: 搜索
             * @param {type}
             * @return: -
             */
            search() {
                if (this.currTab === 0) {
                    var rpc_input = this.Input.rpc_input.trim().replace(/[ ]/g, '')
                    if (!rpc_input) {
                        this.$layer.msg(this.$t('InputNotNull'))
                        return false
                    } else {
                        this.$router.push({
                            path: '/mainland/fuzzySearch',
                            query: {
                                enterprise_name: encodeURI(encodeURI(rpc_input)),
                                random: Math.floor(Math.random() * 10) // 用于模糊查询失败时触发路由监控重新查询
                            }
                        })
                    }
                } else if (this.currTab === 2) {
                    var norpc_input = this.Input.norpc_input.trim()
                    var norpc_country = this.Input.norpc_country.id
                    if (!norpc_input || !norpc_country) {
                        this.$layer.msg(this.$t('InputNotNull'))
                        return
                    }
                    sessionStorage.setItem('abroadCountryId', this.Input.norpc_country.id)
                    this.$router.push({
                        path: '/abroad/fuzzySearch',
                        query: {
                            enterprise_name: encodeURI(encodeURI(norpc_input)),
                            country: norpc_country,
                            random: Math.floor(Math.random() * 10)
                        }
                    })
                } else if (this.currTab === 1) {
                    var wc_input = this.Input.wc_input.trim()
                    if (!wc_input) {
                        this.$layer.msg(this.$t('InputNotNull'))
                        return false
                    } else {
                        //黑名单查询-区分是否是道琼斯还是路透
                        let channel = localStorage.getItem('channel')
                        if (channel == '1') {
                            this.$router.push({
                                path: '/worldCheck/fuzzySearchDQS',
                                query: {
                                    flag: 0,
                                    name: wc_input
                                }
                            })
                        } else {
                            this.$router.push({
                                path: '/worldCheck/fuzzySearch',
                                query: {
                                    name: encodeURI(wc_input)
                                }
                            })
                        }
                    }
                }
            }
        },
        created() {
            // 查询境外企业国家列表
            // 为保证可以在axios.js中统一添加auth_token入参，无参数时需传{}
            this.$api.getAbroadCountryList({}).then(res => {
                if (res.data.error_no === '0000') {
                    this.CountryData = res.data.data
                    // 选中上次选择国家对应的当前语言
                    var _this = this
                    if (!sessionStorage.getItem('abroadCountryId')) {
                        return
                    }
                    for (var i = 0; i < _this.CountryData.length; i++) {
                        var item = _this.CountryData[i]
                        if (item.id === sessionStorage.getItem('abroadCountryId')) {
                            _this.Input.norpc_country = {
                                label: item.label,
                                id: item.id
                            }
                            break
                        }
                    }
                } else {
                    this.ErrorModel(res.data)
                }
            }).catch(error => {
                console.log(error)
            })
        },
        mounted() {
            var _this = this
            document.querySelector('body').addEventListener('click', function (ev) {
                _this.ifShowSelectUl = false
            })
        },
        computed: {
            // 选中内容
            currTabName: function () {
                return this.currTab === 0 ? this.$t('PRC')
                    : (this.currTab === 1 ? this.$t('GlobalCheck') : (
                        this.$t('NonPRC')
                    ))
            }
        }
    }
</script>
<style scoped>
    @import "../../assets/css/header/inputGroup.css";
</style>



// WEBPACK FOOTER //
// src/components/header/inputGroup.vue